import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SEO from "../SEO";
import { Reveal } from "../Reveal";

const Block = ({ block }) => {
  if (block.type === "ul") {
    return (
      <ul className="mt-3 space-y-2 list-disc pl-5 marker:text-[#FF6B00]">
        {block.items.map((item, i) => (
          <li key={i} className="text-[#475569] leading-relaxed">
            {item}
          </li>
        ))}
      </ul>
    );
  }
  return <p className="mt-3 text-[#475569] leading-relaxed">{block.text}</p>;
};

export default function LegalPageLayout({
  title,
  description,
  path,
  eyebrow,
  heading,
  updated,
  sections,
  testId,
}) {
  return (
    <div className="min-h-screen bg-[#F4F6FB]" data-testid={testId}>
      <SEO title={title} description={description} path={path} />
      <Navbar />

      {/* Header */}
      <section className="relative pt-32 pb-14 overflow-hidden bg-white border-b border-[#E6E9F1]">
        <div className="mb-blob mb-blob-orange mb-anim-a w-[360px] h-[360px] -top-24 right-0" />
        <div className="mb-blob mb-blob-blue mb-anim-b w-[300px] h-[300px] top-10 -left-20" />
        <div className="absolute inset-0 mb-grid-lines opacity-60" />
        <div className="relative max-w-3xl mx-auto px-6 text-center">
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <div className="inline-flex items-center gap-2 rounded-full border border-[#E6E9F1] bg-white px-4 py-1.5 mb-6 shadow-[0_2px_10px_rgba(11,21,51,0.05)]">
              <Sparkles className="w-3.5 h-3.5 text-[#FF6B00]" />
              <span className="text-xs font-medium text-[#475569]">{eyebrow}</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tighter leading-none text-[#0B1533]">
              {heading}
            </h1>
            <p className="mt-5 text-sm text-[#94A3B8]">Last updated: {updated}</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="relative py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 lg:px-8 space-y-12">
          {sections.map((sec, i) => (
            <Reveal key={sec.heading} delay={Math.min(i * 0.03, 0.3)}>
              <div data-testid="legal-section">
                <h2 className="text-xl md:text-2xl font-bold tracking-tight text-[#0B1533]">
                  {sec.heading}
                </h2>
                {sec.blocks.map((block, j) => (
                  <Block key={j} block={block} />
                ))}
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <Footer showCta={false} />
    </div>
  );
}
